// List of all V5 icons that are supported by `Icon`. These map directly
// to the names of `.svg` files. To add an `Icon`, add the `.svg`
// file to the appropriate location and then add the icon to this object.
// This map is for Styleguidist
export const iconNames = {
  actionAttachment: true,
  actionAutoRenew: true,
  actionBookmark: true,
  actionBookmarkFill: true,
  actionBug: true,
  actionBugFill: true,
  actionBuild: true,
  actionCalendar: true,
  actionCalendarFill: true,
  actionCamera: true,
  actionCameraFill: true,
  actionCheckConnection: true,
  actionCheckConnectionFill: true,
  actionCopy: true,
  actionCopyFill: true,
  actionDownload: true,
  actionDrag: true,
  actionEdit: true,
  actionEditCircle: true,
  actionEditCircleFill: true,
  actionEditFill: true,
  actionEmail: true,
  actionEmailFill: true,
  actionExplore: true,
  actionExploreFill: true,
  actionFilter: true,
  actionFlag: true,
  actionFlagFill: true,
  actionInsert: true,
  actionLink: true,
  actionLock: true,
  actionLockFill: true,
  actionMoveToFolder: true,
  actionMoveToFolderFill: true,
  actionPhoto: true,
  actionPhotoFill: true,
  actionPin: true,
  actionPinFill: true,
  actionPlay: true,
  actionPlayFill: true,
  actionRename: true,
  actionRenameFill: true,
  actionResend: true,
  actionResendFill: true,
  actionSend: true,
  actionSendFill: true,
  actionShare: true,
  actionShareFill: true,
  actionSwitchAccount: true,
  actionSwitchAccountFill: true,
  actionTrash: true,
  actionTrashFill: true,
  actionZapDetails: true,
  actionZapDetailsFill: true,
  alertCircle: true,
  alertCircleFill: true,
  alertInfo: true,
  alertInfoFill: true,
  alertTriangle: true,
  alertTriangleFill: true,
  arrowBigDown: true,
  arrowBigLeft: true,
  arrowBigRight: true,
  arrowBigUp: true,
  arrowBranch: true,
  arrowCode: true,
  arrowCodeDots: true,
  arrowConnect: true,
  arrowDropdown: true,
  arrowDropdownCircle: true,
  arrowExit: true,
  arrowLineLeft: true,
  arrowLineRight: true,
  arrowOffsite: true,
  arrowRedo: true,
  arrowRefresh: true,
  arrowSmallDown: true,
  arrowSmallLeft: true,
  arrowSmallRight: true,
  arrowSmallUp: true,
  arrowUndo: true,
  arrowZoom: true,
  commentAdd: true,
  commentAddFill: true,
  commentBlank: true,
  commentBlankFill: true,
  commentConvo: true,
  commentConvoFill: true,
  commentFilled: true,
  commentFilledFill: true,
  commentWaiting: true,
  commentWaitingFill: true,
  fileAdd: true,
  fileAddFill: true,
  fileFile: true,
  fileFileFill: true,
  fileFilled: true,
  fileFilledFill: true,
  fileGuide: true,
  fileGuideFill: true,
  formAdd: true,
  formAddCircle: true,
  formAddCircleOutlined: true,
  formAddSquare: true,
  formAddSquareOutlined: true,
  formBlank: true,
  formCheck: true,
  formCheckCircle: true,
  formCheckCircleOutlined: true,
  formCheckSquare: true,
  formCheckSquareOutlined: true,
  formDash: true,
  formDashCircle: true,
  formDashCircleOutlined: true,
  formDashSquare: true,
  formDashSquareOutlined: true,
  formRadioCheck: true,
  formRadioDot: true,
  formRadioUnchecked: true,
  formToggle: true,
  formX: true,
  formXCircle: true,
  formXCircleOutlined: true,
  magnifyingGlass: true,
  miscBolt: true,
  miscBoltAlt: true,
  miscBoltAltFill: true,
  miscBoltFill: true,
  miscBoltOutlined: true,
  miscClock: true,
  miscClockFill: true,
  miscCloud: true,
  miscCloudCheck: true,
  miscCloudCheckFill: true,
  miscCloudFill: true,
  miscColor: true,
  miscColorFill: true,
  miscCookie: true,
  miscCookieFill: true,
  miscCreditCard: true,
  miscCreditCardFill: true,
  miscDollar: true,
  miscEye: true,
  miscEyeClosed: true,
  miscEyeFill: true,
  miscFingerprint: true,
  miscFire: true,
  miscFireFill: true,
  miscGraph: true,
  miscGraphBox: true,
  miscGraphBoxFill: true,
  miscHand: true,
  miscHandFill: true,
  miscHeadset: true,
  miscHeadsetFill: true,
  miscLearn: true,
  miscLearnFill: true,
  miscList: true,
  miscMic: true,
  miscMicFill: true,
  miscPie: true,
  miscPieFill: true,
  miscPin: true,
  miscPinFill: true,
  miscSecurity: true,
  miscSecurityFill: true,
  miscSteps: true,
  miscSteps1: true,
  miscSteps2: true,
  miscSteps3: true,
  miscStepsAlt: true,
  miscStepsFill: true,
  miscText: true,
  miscTextLong: true,
  miscTimelapse: true,
  miscUptime: true,
  miscUptimeFill: true,
  miscWallet: true,
  miscWalletFill: true,
  miscWorld: true,
  miscWorldFill: true,
  navApps: true,
  navAppsFill: true,
  navBell: true,
  navBellFill: true,
  navBlog: true,
  navBlogFill: true,
  navBriefcase: true,
  navBriefcaseFill: true,
  navCog: true,
  navCogFill: true,
  navDashboard: true,
  navDashboardFill: true,
  navExplore: true,
  navExploreFill: true,
  navFolder: true,
  navFolderFill: true,
  navHelp: true,
  navHelpFill: true,
  navHome: true,
  navHomeFill: true,
  navIntegrations: true,
  navIntegrationsFill: true,
  navInterfaces: true,
  navInterfacesFill: true,
  navMenu: true,
  navMenuAlt: true,
  navMoreHoriz: true,
  navMoreVert: true,
  navSearch: true,
  navSearchFill: true,
  navTable: true,
  navTableFill: true,
  navVersions: true,
  navVersionsFill: true,
  partnerDashboard: true,
  partnerEmbed: true,
  personAccount: true,
  personAdd: true,
  personAddFill: true,
  personCircle: true,
  personCircleFill: true,
  personGroup: true,
  personGroupFill: true,
  personOne: true,
  personOneFill: true,
  ratingCool: true,
  ratingHappy: true,
  ratingHappyAlt: true,
  ratingHeart: true,
  ratingHeartFill: true,
  ratingNeutral: true,
  ratingNeutralAlt: true,
  ratingSad: true,
  ratingSadAlt: true,
  ratingStar: true,
  ratingStarFill: true,
  ratingThumbsBoth: true,
  ratingThumbsBothFill: true,
  ratingThumbsDown: true,
  ratingThumbsDownFill: true,
  ratingThumbsUp: true,
  ratingThumbsUpFill: true,
  ratingVeryHappy: true,
  ratingVeryHappyAlt: true,
  ratingVerySad: true,
  ratingVerySadAlt: true,
  ratingWink: true,
  ratingWinkAlt: true,
  statusFilter: true,
  statusFilterFill: true,
  statusPaused: true,
  statusPlaying: true,
  statusPlayingFill: true,
  team: true,
  teamFill: true,
  upAndDownArrows: true,
  x: true,
  zapierLogo: true,
  zapDetails: true,
} as const;
type IconsMap = {
  [k: string]: string;
};
export const iconsMap: IconsMap = Object.keys(iconNames).reduce(
  (icons, iconName) => {
    icons[iconName] = `./${iconName}.svg`;
    return icons;
  },
  {} as IconsMap
);

export type IconName = keyof typeof iconNames;
